<template>
  <div id="page-wrapper" v-if="loggedIn" class="hidden-xs">
    <div class="container">
      <div class="row page-section form-padding">
        <div class="col-md-4 col-xs-6">
          <form class="prepaid-form" @submit.prevent="proceedToPlan">
            <h5>{{ pageTitle }}</h5>
            <DropDown
              @on-change="selectOperator"
              title="Select Operator"
              valueName="operator"
              :items="operators"
            />
            <input
              class="account-id__input"
              type="text"
              placeholder="Subscriber ID"
              v-model="recharge_account_id"
              @keyup="validateMobileNumber"
              v-numericOnly
            />
            <!-- <p class="input-error-text">{{ validationTextMobile }}</p> -->

            <input
              class="account-id__input"
              type="text"
              placeholder="Amount"
              v-model="selectedPlan"
              v-numericOnly
            />
            <p class="error-text mt-20" v-if="pageError">{{ pageError }}</p>
            <p
              class="error-text mt-20"
              v-else-if="!pageError&&selectedPlan>0&&selectedPlan<minRechargeAmount"
            >Min. recharge amount is {{minRechargeAmount|formatCurrency}}</p>
            <ActionButton
              title="Continue"
              :disabled="
                !(
                  recharge_account_id.length > 0 &&
                  operator &&
                  selectedPlan >= minRechargeAmount
                )
              "
            />
          </form>
        </div>
        <div class="scroll-section" v-show="operator">
          <Plan />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
import DropDown from "@/components/DropDown/index";
import Plan from "@/components/Plan";
export default {
  name: "DTHWeb",
  data() {
    return {
      recharge_amount: "",
      showPlans: false,
      selected_tab: "All",
      pageError: "",
      pageTitle: this.$route.meta.pageTitle
    };
  },
  components: { ActionButton, DropDown, Plan },
  computed: {
    ...mapGetters([
      "operators",
      "regions",
      "loggedIn",
      "operator",
      "valid_recharge_account_id"
    ]),
    recharge_account_id: {
      get() {
        return this.$store.state.recharge.recharge_account_id;
      },
      set(value) {
        return this.$store.dispatch("setRechargeAccountId", value);
      }
    },
    selectedPlan: {
      get() {
        return this.$store.state.recharge.selectedPlan;
      },
      set(value) {
        return this.$store.dispatch("selectPlan", { amount: value });
      }
    },
    minRechargeAmount() {
      return this.operators.find(e => e.operator === this.operator)
        .minRechargeAmount;
    }
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "BILL_PAYMENT_SELECTED",
      propertyName: "BILL_TYPE",
      propertyValue: "DTH"
    });
    this.$store.dispatch("setRechargeOperator", "");
    this.$store.dispatch("setRechargeAccountId", "");
    this.$store.dispatch("selectPlan", "");
    this.$store
      .dispatch("getOperatorsAndRegions", this.$route.meta.value)
      .then(resp => {
        this.operatorsLoaded = true;
      });
  },
  methods: {
    validateMobileNumber(getInput) {
      var mobileNumber = getInput.target.value;
      this.$store.dispatch("setRechargeAccountId", mobileNumber);
    },
    selectOperator(getInput) {
      this.$store.dispatch("setRechargeOperator", getInput.target.value);
      this.$store.dispatch("getPlans", {
        type: this.$route.meta.value,
        operator: this.operator.trim()
      });
      this.$store.dispatch("selectCategory", "All");
      this.$store.dispatch("setRechargeAccountId", "");
      this.$store.dispatch("selectPlan", "");
    },
    proceedToPlan() {
      this.pageError = "";
      this.$router.push({
        name: "ChoosePlanWeb",
        params: { category: this.$route.meta.value, routeType: "DTHWeb" }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.account-id {
  &__input {
    font-size: 20px;
    padding: 8px 16px;
    &::placeholder {
      font-size: 16px;
      color: #d6d4d4;
    }
    width: 100%;
    border-radius: 3px;
    border: solid 0.2px #d4d4d4;
    background-color: #ffffff;
    margin-top: 24px;
  }
}
.categories {
  display: flex;
  overflow-x: auto;
  padding-left: 21px;
  background: #fff;
  &__item {
    padding: 11px 0;
    margin-right: 33px;
    font-size: 16px;
    letter-spacing: 0.34px;
    color: #4d4d4d;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
  }
}

.plan_selected {
  color: #3482fd;
  border-bottom: 2px solid #3482fd;
}

.offer-item {
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 20px;
  margin-bottom: 5px;
  align-items: flex-start;
  &__text {
    &__description,
    &__subtitle {
      display: block;
    }
    &__description {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.26px;
      color: #4d4d4d;
      margin-bottom: 5px;
      word-break: break-word;
    }
    &__subtitle {
      font-size: 11px;
      letter-spacing: 0.23px;
      color: #979797;
      margin-bottom: 0;
    }
  }
  &__button {
    font-size: 16px;
    font-weight: 900;
    letter-spacing: 0.34px;
    color: #3482fd;
    border-radius: 4px;
    border: solid 1px #3482fd;
    outline: none;
    box-shadow: none;
    padding: 7px 14px;
    background: #fff;
    white-space: nowrap;
    margin-left: 0.4rem;
  }
}
.bstimeslider {
  height: 30px;
  position: relative;
  overflow: hidden;
}

.bktibx {
  float: left;
  margin: 0 40px 0 0;
  font-size: 16px;
  display: block;
  color: #4d4d4d;
  cursor: pointer;
}

#tslshow {
  position: absolute;
  left: 0;
  width: 1200px;
}

#leftArrow {
  position: absolute;
  left: 0px;
  height: 30px;
  background: #f9f9f9;
  z-index: 10;
  cursor: pointer;
}

#rightArrow {
  cursor: pointer;
  position: absolute;
  right: 0px;
  height: 30px;
  background: #f9f9f9;
  z-index: 10;
}

#viewContainer {
  border-bottom: 1px solid #96969666;

  width: 525px;
  height: 100%;
  position: absolute;
  left: 35%;
  margin-left: -180px;
  overflow: hidden;
}

.red-border {
  border: 0.2px solid #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/DTHWeb.vue